import React, { useState } from "react";
import {
  Accordion,
  Alert,
  Button,
  Card,
  Col,
  Form,
  Row,
} from "react-bootstrap";
import toast from "react-hot-toast";

const AreaOfExpertise = ({ formData, setFormData, error }) => {
  const [validated, setValidated] = useState(false);
  const [otherInputs, setOtherInputs] = useState({});

  const sections = {
    Advising: [
      "Consultation",
      "Market Studies",
      "Risk assessment",
      "Negotiation",
      "Others",
    ],
    "Business Matches": [
      "Buyer Search",
      "Indenting Agent",
      "Business Partners",
      "Market Entry Assistance",
      "Others",
    ],
    "Product Registrations": [
      "Pharmaceutical",
      "Food Items",
      "Chemicals",
      "Meat Products",
      "Others",
    ],
    "IP Consulting": [
      "Trade-Service Mark",
      "Brand Name",
      "Copyrights",
      "Patents",
      "Others",
    ],
    "Business Partner Selection": [
      "Scrutiny",
      "Vetting",
      "Credit Check",
      "Validation",
      "Others",
    ],
    Agreement: [
      "Collaboration",
      "Joint Ventures",
      "Sales Office",
      "Contract Drafting",
      "Others",
    ],
    "Dispute Resolution": [
      "Mediation",
      "Conciliation",
      "Arbitration",
      "Court of law",
      "Others",
    ],
    Facilitation: [
      "Logistics",
      "Custom clearance",
      "Transportation",
      "Tariff & Non Tariff",
      "Others",
    ],
  };

  const countSelectedInSection = (section) =>
    formData.expertise[section]?.length || 0;

  const handleSelection = (section, item) => {
    setValidated(false);

    setFormData((prevFormData) => {
      const currentSelection = prevFormData.expertise[section] || [];
      const isSelected = currentSelection.includes(item);

      if (!isSelected) {
        if (currentSelection.length >= 6) {
          toast.error(
            `You can select a maximum of 6 expertise from ${section}`
          );
          return prevFormData;
        }
        return {
          ...prevFormData,
          expertise: {
            ...prevFormData.expertise,
            [section]: [...currentSelection, item],
          },
        };
      } else {
        return {
          ...prevFormData,
          expertise: {
            ...prevFormData.expertise,
            [section]: currentSelection.filter(
              (expertise) => expertise !== item
            ),
          },
        };
      }
    });
  };

  const handleOtherExpertiseAdd = (section) => {
    const newExpertise = otherInputs[section]?.trim();
    if (!newExpertise) return;

    setFormData((prevFormData) => {
      const currentOthers = prevFormData.expertise[section] || [];

      if (currentOthers.includes(newExpertise)) {
        toast.error(`"${newExpertise}" is already added to ${section}`);
        return prevFormData;
      }

      if (currentOthers.length >= 6) {
        toast.error(`You can select a maximum of 6 expertise from ${section}`);
        return prevFormData;
      }

      return {
        ...prevFormData,
        expertise: {
          ...prevFormData.expertise,
          [section]: [...currentOthers, newExpertise],
        },
      };
    });

    setOtherInputs((prev) => ({ ...prev, [section]: "" }));
  };

  const removeOtherExpertise = (section, expertiseToRemove) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      expertise: {
        ...prevFormData.expertise,
        [section]: prevFormData.expertise[section].filter(
          (expertise) => expertise !== expertiseToRemove
        ),
      },
    }));
  };

  return (
    <Form noValidate validated={validated}>
      <h5 className="fw-bold">
        Area of Expertise <span className="text-danger">*</span>
      </h5>
      <div
        className="text-xs text-danger fw-bold"
        style={{ fontSize: "0.9rem" }}
      >
        <span className="text-danger">*</span> You can select up-to 4 'Area of Expertise' out of total 8.
      </div>
      <div
        className="text-xs text-danger fw-bold"
        style={{ fontSize: "0.9rem" }}
      >
        <span className="text-danger">*</span> Under Area of Expertise, 4 'by default Services' are given.
      </div>
      <div
        className="text-xs text-danger fw-bold"
        style={{ fontSize: "0.9rem" }}
      >
        <span className="text-danger">*</span> In case you wish to have additional services, you can Add other 2.services.
      </div>
      <div
        className="text-xs text-danger fw-bold"
        style={{ fontSize: "0.9rem" }}
      >
        <span className="text-danger">*</span> Carefully chose your Services so as to match the requirements of Indian Business Participants.
      </div>
      <hr />

      <Accordion defaultActiveKey="0">
        {Object.entries(sections).map(([section, items], index) => (
          <Accordion.Item key={section} eventKey={index.toString()}>
            <Accordion.Header>
              <div className="d-flex justify-content-between align-items-center w-100 me-3">
                <h6 className="mb-0 fw-bold">{section}</h6>
                <span className="badge bg-primary">
                  {countSelectedInSection(section)}/6 selected
                </span>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <Row xs={2} md={3} lg={4} className="g-2 mb-2">
                {items.map((item) => (
                  <Col key={item}>
                    <Card
                      className={`cursor-pointer ${formData.expertise?.[section]?.includes(item)
                        ? "bg-primary text-white"
                        : "bg-light"
                        }`}
                      onClick={() => handleSelection(section, item)}
                      style={{ cursor: "pointer" }}
                    >
                      <Card.Body className="p-2 text-center">{item}</Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>

              {formData.expertise?.[section]?.includes("Others") && (
                <div className="mt-3">
                  <Form.Label className="fw-bold fs-6">
                    Others Expertise:
                  </Form.Label>
                  <div className="d-flex gap-2 mb-2">
                    <Form.Control
                      type="text"
                      placeholder="Enter expertise"
                      value={otherInputs[section] || ""}
                      onChange={(e) =>
                        setOtherInputs((prev) => ({
                          ...prev,
                          [section]: e.target.value,
                        }))
                      }
                      maxLength={30}
                    />
                    <Button
                      onClick={() => handleOtherExpertiseAdd(section)}
                      disabled={!otherInputs[section]?.trim()}
                    >
                      Add
                    </Button>
                  </div>

                  {formData.expertise[section]?.filter(
                    (exp) => exp !== "Others"
                  ).length > 0 && (
                      <div className="mt-3">
                        <div className="fw-bold mb-2">Added Expertise:</div>
                        {formData.expertise[section]
                          ?.filter((exp) => exp !== "Others")
                          .map((expertise, idx) => (
                            <div
                              key={idx}
                              className="d-flex justify-content-between align-items-center mb-2 p-2 bg-light rounded"
                            >
                              <span>{expertise}</span>
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() =>
                                  removeOtherExpertise(section, expertise)
                                }
                              >
                                Remove
                              </Button>
                            </div>
                          ))}
                      </div>
                    )}
                </div>
              )}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
      <hr />
    </Form>
  );
};

export default AreaOfExpertise;
